const row = (MyStores, Marketplace, StoreName, Link, Remove) => ({
  MyStores,
  Marketplace,
  StoreName,
  Link,
  Remove,
});

export { row };
